import { useQuery } from "@tanstack/react-query";
import { supabaseClient } from "../utils/supabase";

export function useUser() {
    return useQuery({
        queryKey: ["user"],
        queryFn: async () => {
            const {
                data: { session },
            } = await supabaseClient.auth.getSession();
            return session?.user ?? null;
        },
        staleTime: 1000 * 60, // 5 minutes
        retry: false,
    });
}
